import { motion } from "framer-motion";

export function FadeUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay, ease: [0.2, 0.8, 0.2, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ children, className = "" }) {
  return (
    <p className={`text-xs md:text-sm tracking-[0.28em] text-[#7A2E5D] uppercase font-medium ${className}`}>
      {children}
    </p>
  );
}
